export const focusedRollupText = "OEw5oc";
export const otherRollupText = "X27Igd";
export default {focusedRollupText,otherRollupText};